import { equal, not, and } from '@ember/object/computed';
import EmberObject from '@ember/object';
import { State } from '@square/dashboard-protos/models/squareup/inventory/api';

// eslint-disable-next-line ember/no-classic-classes
const AdjustmentReason = EmberObject.extend({
  token: null,
  translationKey: null,
  fromState: null,
  toState: null,
  logName: null,
  isFromInStock: equal('fromState', State.SqState.IN_STOCK),
  isToInStock: equal('toState', State.SqState.IN_STOCK),
  isNotToInStock: not('isToInStock'),
  isFromNoneState: equal('fromState', State.SqState.NONE),
  isFromReturnedByCustomerState: equal('fromState', State.SqState.RETURNED_BY_CUSTOMER),
  isFromUnlinkedReturnState: equal('fromState', State.SqState.UNLINKED_RETURN),
  isSettingStock: and('isFromInStock', 'isToInStock'),
  isRestocking: and('isFromUnlinkedReturnState', 'isToInStock'),
  isReturningStock: and('isFromReturnedByCustomerState', 'isToInStock'),
  isAddingNewStock: and('isFromNoneState', 'isToInStock'),
  isRemovingStock: and('isFromInStock', 'isNotToInStock')
});
export default AdjustmentReason.reopenClass({
  RECEIVED: AdjustmentReason.create({
    logName: 'RECEIVED',
    translationKey: 'inventory.adjustmentReasons.stockReceived',
    fromState: State.SqState.NONE,
    toState: State.SqState.IN_STOCK
  }),
  RECOUNT: AdjustmentReason.create({
    logName: 'RECOUNT',
    translationKey: 'inventory.adjustmentReasons.recount',
    fromState: State.SqState.IN_STOCK,
    toState: State.SqState.IN_STOCK
  }),
  DAMAGED: AdjustmentReason.create({
    logName: 'DAMAGED',
    translationKey: 'inventory.adjustmentReasons.damage',
    fromState: State.SqState.IN_STOCK,
    toState: State.SqState.WASTE
  }),
  THEFT: AdjustmentReason.create({
    logName: 'THEFT',
    translationKey: 'inventory.adjustmentReasons.theft',
    fromState: State.SqState.IN_STOCK,
    toState: State.SqState.NONE
  }),
  LOSS: AdjustmentReason.create({
    logName: 'LOSS',
    translationKey: 'inventory.adjustmentReasons.loss',
    fromState: State.SqState.IN_STOCK,
    toState: State.SqState.NONE
  }),
  RESTOCK: AdjustmentReason.create({
    logName: 'RESTOCK',
    translationKey: 'inventory.adjustmentReasons.restock',
    fromState: State.SqState.UNLINKED_RETURN,
    toState: State.SqState.IN_STOCK
  }),
  TRANSFER: AdjustmentReason.create({
    logName: 'TRANSFER',
    translationKey: 'inventory.adjustmentReasons.transfer',
    fromState: State.SqState.IN_STOCK,
    toState: State.SqState.IN_STOCK
  }),
  LINKED_RESTOCK: AdjustmentReason.create({
    logName: 'LINKED_RESTOCK',
    translationKey: 'inventory.adjustmentReasons.linkedRestock',
    fromState: State.SqState.RETURNED_BY_CUSTOMER,
    toState: State.SqState.IN_STOCK
  }),
  RETURNED_DAMAGED: AdjustmentReason.create({
    logName: 'RETURNED_DAMAGED',
    translationKey: 'inventory.adjustmentReasons.returnedDamaged',
    fromState: State.SqState.RETURNED_BY_CUSTOMER,
    toState: State.SqState.WASTE
  })
});

// NB(kevinx): Only add adjustment reasons here if you want them to show up in the list of stock
// actions a merchant can manually make from Dashboard. We should probably rename this const to make
// this more obvious.
export const ADJUSTMENT_REASONS = [AdjustmentReason.RECEIVED, AdjustmentReason.RECOUNT, AdjustmentReason.DAMAGED, AdjustmentReason.THEFT, AdjustmentReason.LOSS, AdjustmentReason.RESTOCK];